import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { ImagePresets } from "@routes/Article/components/ArticleThumbnail/utils/enums";
import { NavigationItem } from "@typings/Navigation";
import { CaaSImageFilters } from "@typings/OptimisedImage";
import { cn } from "@util/helpers";

type VerticalsStoriesProps = {
  /** Individual article */
  cardProps: ComponentProps<typeof Card>;
  /** Index of the article in the list */
  index: number;
  /** Section details  */
  section: NavigationItem;
};

/**
 * Renders a single story card for the Verticals section.
 */
const VerticalsStories = ({
  cardProps,
  section,
}: VerticalsStoriesProps): React.ReactElement => {
  const imageFilters: CaaSImageFilters = {
    w: ImagePresets.LARGE,
    dpr: 1,
    f: "webp",
  };

  const variant: CardVariations = {
    image: {
      position: "",
      width: "!w-120px lg:!w-full",
      imageClassName: "object-cover aspect-3x2",
      filters: imageFilters,
    },
    content: {
      width: "w-full-120px lg:w-full",
      extraClass: cn("pl-4 lg:pl-0 lg:pt-3"),
      updatedTimeColor: "text-red",
    },
    title: {
      color: "text-gray-850",
      size: "text-base",
      extraClass: "font-lct",
    },
  };

  return (
    <div
      className={cn(
        "story border-t border-gray-850 pb-10 pt-3 md:col-span-1 md:pb-3"
      )}
      data-testid="homepage-verticals-stories-individual-component"
    >
      <BlockTitle
        rootClassName="!text-lg mb-2"
        rootLinkClassName=""
        text={section.label?.toUpperCase() ?? ""}
        link={section.link}
      />

      <Card {...cardProps} variations={variant} />
    </div>
  );
};

export default VerticalsStories;
